import classNames from 'classnames';
import type { FC } from 'react';

const FILE_EXTENSION_COLORS: Record<string, string> = {
  pdf: 'text-red-400',
  doc: 'text-primary-800',
  xls: 'text-green-400',
  jpg: 'text-taxes',
  png: 'text-taxes',
  gif: 'text-taxes',
};

const FileExtensionBadge: FC<{ extension: string }> = ({ extension }) => (
  <div className="w-8 h-7 bg-primary-50 border-b-2 border-b-primary-200 rounded-md flex items-center justify-center text-center">
    <p
      className={classNames(
        'font-semibold text-xs',
        FILE_EXTENSION_COLORS[extension] || '',
      )}
    >
      {extension.toUpperCase()}
    </p>
  </div>
);

export default FileExtensionBadge;
